import Enum from './Domain'

class EditionType extends Enum { }

EditionType.initEnum(['ALL', 'NONE', 'END_DATE'])

export default EditionType
